<div class="detail-dialog">

    <mat-tab-group [(selectedIndex)]="dayQualityTabIndex" class="tabs" dynamicHeight>

        @for (dayQualityId of dayQualityEntries; track dayQualityId) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="label">
                        <img alt="{{'DAY_QUALITY.' + dayQualityId.toUpperCase() | translate}}"
                              class="attribute-img" src="assets/images/day_quality/{{dayQualityId}}.webp">
                        <p>{{ 'DAY_QUALITY.' + dayQualityId.toUpperCase() | translate }}</p>
                    </div>
                </ng-template>
                <article class="description">
                    <h2>
                        {{ 'DAY_QUALITY.' + dayQualityId.toUpperCase() | translate }}
                    </h2>
                    <p [innerHTML]="'DAY_QUALITY_INFO.' + dayQualityId.toUpperCase()  | translate"></p>
                </article>
            </mat-tab>
        }

    </mat-tab-group>

</div>
